import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { NavigateLink } from '@/common/components/links/NavigateLink';
import Icon from '@/common/components/Icon';
import { Colors } from '@/common/colors/colors';

const IconsWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${Colors.darkBlue};
	gap: 10px;
`;

const THead = styled.thead`
	th {
		background-color: #7b0b8c;
	}
`;

const TBody = styled.tbody`
	td {
		background-color: #ffefd0;
	}
`;

export const CallingNow = ({ data = [] }) => {
	return (
		<table
			className='styled-table '
			style={{ minWidth: '650px', maxWidth: '650px' }}
		>
			<THead>
				<tr>
					<th colSpan={7}>Calling Users</th>
				</tr>
				<tr>
					<th>No.</th>
					<th>Coun.</th>
					<th>Username</th>
					<th>Number</th>
					<th>Calling at</th>
					<th>Actions</th>
				</tr>
			</THead>
			<TBody className='queue'>
				{data.length > 0 ? (
					data
						.sort(
							(a, b) =>
								new Date(b.calling_at).getTime() -
								new Date(a.calling_at).getTime(),
						)
						.map((element, i) => (
							<tr key={i}>
								<td>{i + 1}</td>
								<td>{element.country}</td>
								<td>{element.username}</td>
								<td>
									{element.phone_number
										.match(/.{1,3}/g)
										.map((substring) => substring + ' ')}
								</td>
								<td>{moment(element.calling_at).format('DD/MM HH:mm:ss')}</td>
								<td>
									<IconsWrapper>
										<NavigateLink
											target='_blank'
											to={`/settings/user/list?mode=show&userId=${element.consultant}`}
										>
											<Icon name='fa fa-user animation-scale' />
										</NavigateLink>
										<NavigateLink
											target='_blank'
											to={`/dashboard/contact/${element.contact}`}
										>
											<Icon name='fa fa-address-book animation-scale' />
										</NavigateLink>
										<NavigateLink
											target='_blank'
											to={`/dashboard/order/${element.order}`}
										>
											<Icon name='fa fa-address-card animation-scale' />
										</NavigateLink>
									</IconsWrapper>
								</td>
							</tr>
						))
				) : (
					<tr>
						<td colSpan={7}>There is no users</td>
					</tr>
				)}
			</TBody>
		</table>
	);
};
